import { TemplateFormValues } from "../templateForm";

export interface WizardStep {
  step: number;
  title: string;
  description: string;
}

export const WIZARD_STEPS: WizardStep[] = [
  { step: 1, title: "Start", description: "What are you building?" },
  { step: 2, title: "Prompt", description: "What the agent knows and how it behaves." },
  { step: 3, title: "Skills", description: "What it can do on a call, and what it records." },
  { step: 4, title: "Voice", description: "How it sounds and what runs it." },
  { step: 5, title: "Conversation", description: "How calls open, close and behave in between." },
  { step: 6, title: "Deploy", description: "Give an organisation an agent built on this template." },
  { step: 7, title: "Test", description: "Place a real call and hear it." },
];

export const FIRST_WIZARD_STEP = 1;
export const LAST_WIZARD_STEP = 7;
export const DEPLOY_WIZARD_STEP = 6;
export const TEST_WIZARD_STEP = 7;

export const WIZARD_STEP_FIELDS: Record<number, (keyof TemplateFormValues)[]> = {
  1: ["name", "category", "tier"],
  2: [],
  3: ["defaultSkills", "tools", "defaultDeclaredOutcomes"],
  4: [
    "orchestrator",
    "llmProvider",
    "llmModel",
    "sttProvider",
    "sttModel",
    "realtimeVoice",
    "voiceProvider",
    "voiceId",
    "defaultVoiceStability",
    "defaultVoiceSimilarityBoost",
  ],
  5: [
    "defaultGreeting",
    "defaultClosingMessage",
    "aiDisclosureEnabled",
    "silencePromptTimeoutSec",
    "silenceHangupTimeoutSec",
    "silencePromptPhrase",
    "waitPhraseTimeoutSec",
    "temperature",
    "endpointingMs",
    "turnHoldMs",
    "minCallDurationSec",
    "maxDurationSeconds",
  ],
};
